import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { leftNav } from '../../../styled-system/recipes';
import { Collections } from '../../icons/Collections';
import { Model } from '../../icons/Model';
import { IconButton } from '../../ui/form/buttons/button/component/IconButton';
import { LabelFlyOut } from './LabelFlyOut';

export const LeftNav = () => {
  const navigate = useNavigate();

  const handleCollections = useCallback(() => {
    navigate('/app/collections');
  }, [navigate]);

  const handleModels = useCallback(() => {
    navigate('/app/models');
  }, [navigate]);

  return (
    <nav className={leftNav()}>
      <ul>
        <li>
          <LabelFlyOut
            label="Models"
            details="Base models and animations"
            onClick={handleModels}
          >
            <IconButton onClick={handleModels}>
              <Model />
            </IconButton>
          </LabelFlyOut>
        </li>
        <li>
          <LabelFlyOut
            label="Collections"
            details="Groups of kaddos"
            onClick={handleCollections}
          >
            <IconButton onClick={handleCollections}>
              <Collections />
            </IconButton>
          </LabelFlyOut>
        </li>
      </ul>
    </nav>
  );
};
